import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useBookingStore } from '../store/bookingStore';

/**
 * Hook personalizado para gerenciar o formulário de dados do cliente
 * e a submissão do agendamento
 * 
 * @param {Object} options - Opções do hook
 * @param {string} options.salonId - ID do salão
 * @param {Function} options.onSubmitSuccess - Callback para sucesso na submissão
 * @returns {Object} - Funções e estados para manipular o formulário e submissão
 */
export const useClientForm = ({ salonId, onSubmitSuccess }) => {
  // Form context do React Hook Form
  const { 
    register, 
    handleSubmit, 
    formState: { errors }, 
    reset 
  } = useFormContext();
  
  // Estado local para controlar carregamento durante submissão
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Obter dados do store para o resumo e submissão
  const {
    services: selectedServices,
    date: selectedDate,
    time: selectedTime,
    professional: selectedProfessional,
    client,
    resetBooking
  } = useBookingStore();
  
  // Handler de submissão do formulário
  const submitBooking = async (onSubmit) => {
    return handleSubmit(async (formData) => {
      try {
        setIsSubmitting(true);
        
        // Consolidar dados do agendamento
        const bookingData = {
          ...formData,
          services: selectedServices,
          date: selectedDate,
          time: selectedTime,
          professional: selectedProfessional,
          salonId
        };
        
        // Chamar a função de submissão fornecida
        await onSubmit(bookingData);
        
        // Callback de sucesso se fornecido
        if (onSubmitSuccess) {
          onSubmitSuccess();
        }
        
      } catch (error) {
        console.error('Erro ao submeter agendamento:', error);
        throw error;
      } finally {
        setIsSubmitting(false);
      }
    })();
  };
  
  // Resetar formulário e estado
  const resetForm = () => {
    reset({
      client: {
        name: '',
        phone: '',
        email: '',
        notes: ''
      }
    });
    resetBooking();
  };

  return {
    // Estado do formulário
    register,
    errors,
    isSubmitting,
    
    // Dados para o resumo
    bookingData: {
      services: selectedServices,
      date: selectedDate,
      time: selectedTime,
      professional: selectedProfessional,
      client
    },
    
    // Métodos
    handleSubmit,
    submitBooking,
    resetForm
  };
}; 